import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneScanPayload } from '@app-store/slices/scans/one'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneScanPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.scans.one

function* oneScanSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/scan/one/${payload.scanId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneScanSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneScanSagaTask)
}

export default oneScanSaga
